import React, {useContext, useState} from "react";
import {Link, useHistory} from "react-router-dom";
import Firebase from "../../services/firebase"
import {
    ErrorContainer,
    FixelLogo, FormContainer, Row,
    StyledButton,
    StyledForm,
    StyledInput,
    StyledLabel, StyledLeftForm, StyledRightForm,
    StyledStar, StyledTitle, StyledWrapperInput
} from "../signIn/signin.style";

import {StyledFormWrapper, StyledInputGroupRow, StyledSignUp} from "./signup.style"
import google from "../../img/google.png";
import Recommendation from "../commons/recommendation/recommendation.compoenent";
import axios from "axios";
import {useCustomer} from "../../provider/customerProvider";
import {creatCustomer} from "../../services/globalService";

const SignUp = () => {

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [error, setError] = useState(null);
    const [checkBoxConsent, setCheckboxConsent] = useState(false);
    const history = useHistory();
    const {setCustomer, setLoading} = useCustomer();


    const createUserWithEmailAndPasswordHandler = async (event, email, password) => {
        event.preventDefault();
        try{
            let displayName = `${firstName} ${lastName}`;
            const user = await Firebase.register(displayName,email,password);
            try {
                setLoading(true);
                const res = await creatCustomer(user);
                if (res) {// validate res
                    setCustomer(user)
                    history.push('/introduction');
                }
            }catch (error){
                setLoading(false);
            }
        }
        catch(error){
            setError('Error Signing up with email and password');
        }
    };

    const signWithGoogle = () => Firebase.signInWithGoogle().then( async (user)=>{
        try {
            setLoading(true);
            const res = await creatCustomer(user);
            if (res) {
                setCustomer(user)
                history.push('/introduction');
            }
        }catch (error){
            setLoading(false);
        }
    });

    const onChangeHandler = event => {
        const { name, value } = event.currentTarget;
        if (name === "userEmail") {
            setEmail(value);
        } else if (name === "userPassword") {
            setPassword(value);
        } else if (name === "firstName") {
            setFirstName(value);
        } else if (name === 'lastName'){
            setLastName(value);
        }else if(name === 'consent'){
            setCheckboxConsent(!checkBoxConsent);
        }
    };

    return (
        <StyledSignUp>
            <FixelLogo/>
                <StyledFormWrapper>
                    <StyledLeftForm>
                        <FormContainer>
                            {error !== null && (<ErrorContainer>{error}</ErrorContainer>)}
                            <StyledTitle>Create Your Account</StyledTitle>
                            <StyledForm>
                            <StyledInputGroupRow>
                                <div>
                                    <StyledLabel htmlFor="firstName">
                                        First Name
                                        <StyledStar>*</StyledStar>
                                    </StyledLabel>
                                    <StyledInput
                                        type="text"
                                        name="firstName"
                                        value={firstName}
                                        placeholder="First name"
                                        id="firstName"
                                        onChange={event => onChangeHandler(event)}
                                    />
                                </div>
                                <div>
                                    <StyledLabel htmlFor="lastName">
                                        Last Name
                                        <StyledStar>*</StyledStar>
                                    </StyledLabel>
                                    <StyledInput
                                        type="text"
                                        name="lastName"
                                        value={lastName}
                                        placeholder="Last Name"
                                        id="lastName"
                                        onChange={event => onChangeHandler(event)}
                                    />
                                </div>
                            </StyledInputGroupRow>
                            <StyledLabel htmlFor="userEmail">
                                Email
                                <StyledStar>*</StyledStar>
                            </StyledLabel>
                            <StyledInput
                                type="email"
                                name="userEmail"
                                value={email}
                                placeholder="example@example.com"
                                id="userEmail"
                                onChange={event => onChangeHandler(event)}
                            />
                            <StyledLabel htmlFor="userPassword">
                                Password
                                <StyledStar>*</StyledStar>
                            </StyledLabel>
                            <StyledInput
                                type="password"
                                name="userPassword"
                                value={password}
                                placeholder="Your Password"
                                id="userPassword"
                                onChange={event => onChangeHandler(event)}
                            />
                            <StyledWrapperInput>
                                <input
                                    value={checkBoxConsent}
                                    id={"consent"}
                                    type={"checkbox"}
                                    onChange={event => onChangeHandler(event)}
                                    name={"consent"}
                                    required>
                                </input>
                                <StyledLabel htmlFor="consent">
                                    By signing up to Fixel you agree to the <a href="https://fixel.ai/privacy-policy/">terms of use and the privacy policy</a>
                                    <StyledStar>*</StyledStar>
                                </StyledLabel>
                            </StyledWrapperInput>
                        </StyledForm>
                            <Row>
                                <StyledButton
                                    disabled={!checkBoxConsent}
                                    onClick={event => {
                                        createUserWithEmailAndPasswordHandler(event, email, password);
                                    }}
                                >
                                    Sign up
                                </StyledButton>
                            </Row>
                            <p style={ {"marginTop" : "1rem" } }>
                                Already have an account?{" "}
                                <Link to="/signin">
                                    Sign in here
                                </Link>
                            </p>
                        </FormContainer>
                    </StyledLeftForm>
                    <StyledRightForm>
                        <Recommendation/>
                    </StyledRightForm>
                </StyledFormWrapper>
        </StyledSignUp>
    );
};
export default SignUp;